var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12.857,
    viewBox: "0 0 18 12.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "email",
    d: "M18.964,6.75H3.536A1.286,1.286,0,0,0,2.25,8.036V18.321a1.286,1.286,0,0,0,1.286,1.286H18.964a1.286,1.286,0,0,0,1.286-1.286V8.036A1.286,1.286,0,0,0,18.964,6.75ZM17.55,8.036l-6.3,4.358L4.95,8.036ZM3.536,18.321v-9.7l7.348,5.085a.643.643,0,0,0,.733,0l7.348-5.085v9.7Z",
    transform: "translate(-2.25 -6.75)",
    fill: "#74613C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email2.c1035ae7d1ba512933a167fbf9694ba8.svg";
export { ForwardRef as ReactComponent };